import axios from '../axios'
import { logError } from 'shared'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import appConfig from 'app.config'
import { IFaqItem } from 'selfServicePortal/interfaces/i-api-customer'
import { apiRoutes } from 'selfServicePortal/constants/routes'

export async function getFaqService(
	productType: string,
	language: string,
): Promise<IFaqItem[]> {
	const country = appConfig.country.toUpperCase()
	const response = await axios
		.get<IFaqItem[]>(
			apiRoutes.getFaq(country, productType, language.toUpperCase()),
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
	return response
}
